<template>
  <div
    class="fantasy-add-to-team-button"
    v-if="appState.fantasy.showEdit && appState.fantasy.team.playersState[playerKey]">
    <button 
      @click="addToTeam"
      v-if="appState.fantasy.team.playersState[playerKey].canSelect"
      class="clean fullcolor"
      :class="buttonClass"
    >{{addText}}</button>
    <button 
      @click="removeFromTeam"
      v-else-if="appState.fantasy.team.playersState[playerKey].selected > -1"
      class="clean fullcolor reverse"
      :class="buttonClass"
    >{{removeText}}</button>
    <span v-else class="alert">
      <small>{{appState.fantasy.team.playersState[playerKey].reason}}</small>
    </span>
  </div>
</template>
<script>
import { AppState } from '@/state'
export default {
  props: {
    playerKey: String,
    buttonClass: {
      type: String,
      default: null
    },
    addText: {
      type: String,
      default: 'Add to Team'
    },
    removeText: {
      type: String,
      default: 'Remove From Team'
    },
    credit: {
      type: Number,
      default: null
    },
  },
  methods: {
    addToTeam() {
      AppState.instance.fantasy.team.addPlayer(this.playerKey, this.credit)
    },
    removeFromTeam() {
      AppState.instance.fantasy.team.removePlayer(this.playerKey)
    }
  }
}
</script>

